/* ========================================
   WASA Coffee - Custom Scripts
   All JS enhancements for the Luxe theme
======================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ========================================
     2026-03-23 - Scroll-triggered fade-in animations
     Purpose: Sections fade up as they enter the viewport
     FIXED: Sections already in viewport are immediately shown
  ======================================== */

  var sections = document.querySelectorAll('.shopify-section');
  sections.forEach(function (section) {
    // Exclude background decor + fixed-positioned brew sections from
    // wasa-scroll-fade. Reason: wasa-scroll-fade applies a non-none
    // transform, which creates a containing block for position:fixed
    // descendants. Any sticky/fixed UI inside loses viewport scoping.
    if (
      section.classList.contains('wasa-bg-decor-section') ||
      section.classList.contains('wasa-brew-stickynav-section') ||
      section.classList.contains('wasa-brew-timer-dock-section')
    ) {
      return;
    }
    if (
      section.id && (
        section.id.includes('header') ||
        section.id.includes('announcement') ||
        section.id.includes('footer') ||
        section.id.includes('popup') ||
        section.id.includes('video_banner') ||
        section.id.includes('17627651')
      )
    ) {
      return;
    }
    section.classList.add('wasa-scroll-fade');
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Slight delay for visual effect, but make it visible
            setTimeout(function() {
              entry.target.classList.add('is-visible');
            }, 100);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.01,
        rootMargin: '50px 0px 50px 0px'
      }
    );

    document.querySelectorAll('.wasa-scroll-fade').forEach(function (el) {
      // If element is already in viewport, show it immediately
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
  } else {
    // Fallback: show everything
    document.querySelectorAll('.wasa-scroll-fade').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

});
